import { COMMUNITY_ICONS_BUCKET } from '../constants/community-icons';
import { buildPublicStorageObjectUrl } from './build-public-storage-object-url';

/** コミュニティアイコンの公開 URL。未設定は null。 */
export function buildCommunityIconPublicUrl(
  supabaseUrl: string,
  iconPath: string | null | undefined,
  iconUpdatedAt?: string | Date | null,
): string | null {
  return buildPublicStorageObjectUrl(
    supabaseUrl,
    COMMUNITY_ICONS_BUCKET,
    iconPath,
    iconUpdatedAt,
  );
}
